"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectFieldItem = void 0;
var React = require("react");
var core_1 = require("@blueprintjs/core");
var lodash_1 = require("lodash");
var SelectFieldItem = (function (_super) {
    __extends(SelectFieldItem, _super);
    function SelectFieldItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            expand: false
        };
        return _this;
    }
    SelectFieldItem.prototype.render = function () {
        var _this = this;
        var expand = this.state.expand;
        var props = this.props;
        return (props.item.items ?
            expand === false ?
                (React.createElement(core_1.Button, { key: props.item.name, intent: (0, lodash_1.isEqual)(props.item.name, props.value) ? core_1.Intent.PRIMARY : core_1.Intent.NONE, text: props.item.name, onClick: function () { return _this.setState({ expand: true }); } })) :
                (React.createElement("div", null, props.item.items.map(function (subItem, j) { return typeof subItem === 'string' ?
                    (React.createElement(core_1.Button, { key: j, className: "bp3-popover-dismiss", intent: (0, lodash_1.isEqual)(subItem, props.value) ? core_1.Intent.PRIMARY : core_1.Intent.NONE, active: (0, lodash_1.isEqual)(subItem, props.value), text: subItem, onClick: function () { return props.onItemSelect({ name: subItem }); } }))
                    :
                        (React.createElement(SelectFieldItem, { item: subItem, value: props.value, onItemSelect: props.onItemSelect })); })))
            : props.item.isInput ?
                (React.createElement("input", { className: "pv1 w3", id: 'select_input_field', placeholder: "Type", value: props.value ? props.value : undefined, onChange: function (value) { return props.onItemSelect({ name: value.target.value }); } }))
                :
                    (React.createElement(core_1.Button, { className: "bp3-popover-dismiss", key: props.item.name, intent: (0, lodash_1.isEqual)(props.item.name, props.value) ? core_1.Intent.PRIMARY : core_1.Intent.NONE, text: props.item.name, onClick: function (e) { return props.onItemSelect({ name: props.item.name }); } })));
    };
    return SelectFieldItem;
}(React.Component));
exports.SelectFieldItem = SelectFieldItem;
//# sourceMappingURL=SelectFieldItem.js.map